import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  contentWrapper: {
    marginBottom: '3.8rem',
  },
  categoryName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500,
    },
    color: colors.neutral[900],
    margin: [0],
    textTransform: 'uppercase',
  },
  categoryWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: colors.neutral[700],
    borderBottom: '0.1rem solid #C1C7CD',
    marginBottom: '2.1rem',
  },
  groupName: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
  },
  contactFieldBox: {
    '&:not(:last-child)': {
      paddingBottom: '1.6rem',
    },
  },
  fieldName: {
    textTransform: 'uppercase',
    color: colors.neutral[500],
    margin: [0],
    font: {
      size: '1.4rem',
      lineHeight: '2rem',
      weight: 700,
    },
  },
  fieldValue: {
    paddingTop: '0.4rem',
    margin: [0],
    wordBreak: 'break-word',
    font: {
      size: '1.8rem',
      lineHeight: '2.8rem',
      weight: 400,
    },
  },
  editContactInfo: {
    marginRight: '-3rem',
  },
  aorWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tag: {
    lineHeight: '2rem',
    textAlign: 'center',
    verticalAlign: 'middle',
    padding: '0.4rem 0rem',
    borderRadius: '14px',
    fontSize: '1.2rem',
    width: '10rem',
    backgroundColor: colors.red[200],
    color: colors.neutral[900],
  },
  accountRepBlock: {
    paddingTop: '2.6rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
